module.exports = __webpack_public_path__ + "img/04.d085f35f.jpg";